import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EmailService } from 'src/app/private/services/email.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';


@Component({
  selector: 'app-email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.scss']
})
export class EmailSettingsComponent {
  active = "gmail"
 email:EmailSetting = new EmailSetting();
 @ViewChild("priceSettingsForm")
 EmailForm!: NgForm;
 isSubmitted:boolean = false;
 constructor(private tracker: TrackingService,private toast:ToastrService,private api:EmailService,private localStorage:LocalStorageService)
 {
 
 }
 ngOnInit()
 {
  let param = {
    hospital_id:this.localStorage.getHospitalId(),
    center_id:this.localStorage.getCenterId()
  }
  this.api.getEmailConfig(param).subscribe(
  {
   next:(res)=>{
    if(res)
    {
      this.email = res;
      this.email.password = ""
      console.log(this.email)
    }

   }
  }
  )
 }

 save(isValid:boolean)
 {
  this.isSubmitted = true;
  if(isValid)
  {
    this.email.hospital_id = this.localStorage.getHospitalId();
    this.email.center_id = this.localStorage.getCenterId();
    console.log(this.email)
    if(this.email.id)
    {
      this.api.updateEmailConfig(this.email).subscribe({
        next:(res)=>{
          if(res)
          {
             const desc = `Email settings updated for client: ${this.email.clientName} (${this.email.clientEmailId})`;
      this.tracker.track("Edit", "Email", desc); // ✅ Tracker
            this.toast.success("Setting Saved...")
          }
        },
        error:(e)=>
        {
  
        }
      })
    }
    else
    {
      this.api.createEmailConfig(this.email).subscribe({
        next:(res)=>{
          if(res)
          {
            const desc = `Email settings created for client: ${this.email.clientName} (${this.email.clientEmailId})`;
      this.tracker.track("Create", "Email", desc); // ✅ Tracker
            this.toast.success("Setting Saved...")
          }
        },
        error:(e)=>
        {
  
        }
      })
    }

 
  }
 }

}

export class EmailSetting {
  id!:Number;
  hospital_id:string = "";
  center_id:string = "";
  clientCompliments:string = "";
  clientName:string = "";
  password!:string;
  fromEmail:string = "";
  port:string = "";
  host:string = "";
  clientEmailId:string = "";
  provider:string = "";
}